import {Component, Input, OnInit} from '@angular/core';
import {CompanyContractModel, ContractStepModel, ContractWrapperModel} from '../../../../models/contract.model';
import {ModalService} from '../../../../services/modal/modal.service';
import {CrmService} from '../../../../services/api/crm.service';
import {GraphServiceService} from '../../../../services/graph-service.service';
import {TranslateService} from '@ngx-translate/core';
import {
    BUSINESS_PROCESS_LAYER_ID,
    CONTRACT_LAYER_ID,
    DagreNodesOnlySettings,
    IKnUIOptions,
    INodeChangeEvent,
    IStageSettings,
    Node,
    TLayerIDs
} from '../../../graph-konva/models/graph-kn.cm-api-models';
import {Subscription} from 'rxjs';
import {MatDialog,} from '@angular/material/dialog';
import {ContractDataService } from '../../services/contract-data.service';
import {AppContractStepComponent } from '../contract-step/contract-step.component';
import {ContractStepNameService } from '../../services/contract-step-name.service';
import {ContractGraphService } from '../../services/contract-graph.service';
import { EdgePointerType, EEdgyType, ELayoutAlgorithms } from '../../../graph-konva/models/graph-kn.model-enums';
import { IContractStepModelExt } from '../../../graph-konva/models/graph-kn.model-interfaces';

@Component({
    selector: 'app-roadmap-graph',
    templateUrl: './roadmap-graph.component.html',
    styleUrls: ['./roadmap-graph.component.scss'],
})
export class RoadmapGraphComponent implements OnInit {

    public stageSettings: IStageSettings = {
        offsetY: -5,
        width: window.innerWidth
    }
    public graphUISetting: Map<TLayerIDs, IKnUIOptions> = new Map([
        [CONTRACT_LAYER_ID, {
            draggable:true,
            showEdit: true,
            showDelete: true,
            showCreateNode: true,
            showDeleteEdge: false,
            
        }],
        [BUSINESS_PROCESS_LAYER_ID, {
            draggable:true,
            showDetails: true,
            showUsers: true,
            showStatusPanel: true,
            showDeleteEdge: false,
            closeLayerButton:true
        }]
    ])
    public layoutDagreSettings: Map<TLayerIDs, DagreNodesOnlySettings> = new Map([
      [CONTRACT_LAYER_ID, {
          marginX: 50,
          marginY: window.innerHeight * 0.06,
          ranker: 'longest-path',
          nodeWidthAdaptive: false,
          layoutModel: 'line', // layoutModel:'line'
          module:ELayoutAlgorithms.Local,
          algorithmEdges:ELayoutAlgorithms.Local,
          edgeType:EEdgyType.SmoothStep,
          pointerType:EdgePointerType.Arrow, 
      }],
      [BUSINESS_PROCESS_LAYER_ID,	{    
        //DAGRE
/*           module:ELayoutAlgorithms.Darge,  
          algorithmEdges:ELayoutAlgorithms.Darge,
          edgeType:EEdgyType.Dagre,
          pointerType:EdgePointerType.Arrow,
          ranker: 'network-simplex', */
        //ELK
          module:ELayoutAlgorithms.ELK,  
          edgeType:EEdgyType.Dagre,
          pointerType:EdgePointerType.Arrow,
          algorithmEdges:ELayoutAlgorithms.ELK,
          ranker: 'layered',
          rankPadding: 80,
          nodePadding: 50,  
          marginX: 50,
          marginY: window.innerHeight * 0.0,
          heigt: window.innerHeight ,
          width: window.innerWidth -100,
          nodeWidthAdaptive:false
        }]
      ])
    @Input() public roadmap!: ContractStepModel[];
    @Input() public canEdit!: boolean;
    @Input() public projects!: CompanyContractModel[];
    @Input() public contractGuid!: string;
    @Input() newStep!: string;

    layout = {
        name: 'preset',
        rankDir: 'LR',
        directed: true,
        padding: 0,
    };


    private subscriptions = new Subscription()

    constructor(
        public contractGraphService: ContractGraphService,
        public contractDataService: ContractDataService,
        public contractStepNameService: ContractStepNameService,
        public modalService: ModalService,
        public crmService: CrmService,
        public graphService: GraphServiceService,
        protected translate: TranslateService,
        private dialog: MatDialog
    ) {
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    ngOnInit(): void {
        this.contractGraphService.prepareGraph(true,true,this.contractGuid,{},this.roadmap);
    }

    handleNodeEvent(event: INodeChangeEvent) {
        switch (event.action) {
            case 'EDIT_NODE':
                this.nodeEditViewHandler(event)
                break;
            case 'DELETE_NODE':
                this.nodeDeleteHandler(event.data)
                break;
        }
    }

    nodeEditViewHandler(event: INodeChangeEvent) {
        let openModal = true
        this.canEdit = event.canEdit;
        let stepData = event.data.contract_step_data
        let targetData = stepData? this.contractDataService.getCachedStepTargetData(stepData) : null

        if (
            event.pureAction !== true
            && stepData?.target_type === 'sub_contract'
            && stepData.target_key
            && (targetData as ContractWrapperModel)?.roadmap_active?.steps?.length
        ) {
            this.contractGraphService.subContractPrepareGraphData(stepData,this.contractGuid)
            openModal = false
        }
        if (openModal && stepData) {
            this.openStepDialogForm(stepData)
        }
    }

    nodeDeleteHandler(data: Node) {
      let roadMap = this.contractDataService.ContractDataCachedByGuid.get(this.contractGuid)?.contract?.roadmap_active
      let stepIndex = roadMap?.steps?.findIndex(step => step.guid === data.data.id)
      stepIndex? roadMap?.steps?.splice(stepIndex, 1) : null;
      this.contractGraphService.prepareGraph(true,true,this.contractGuid,{},roadMap?.steps)
      this.contractDataService.subContractEdited.next(true)
    }

    openStepDialogForm(nodeData: IContractStepModelExt ) {
        let dialogStepRef = this.dialog.open(AppContractStepComponent, {
            maxWidth: '1500px',
            panelClass: 'trasnparent-modalbox'
        })
/*         dialogStepRef.afterClosed().subscribe(() => {
            let editedStep: number = this.roadmap.findIndex(el => el.guid === event.data.data?.step.guid);
            this.roadmap[editedStep] = event.data.data?.step 
            this.contractDataService.subStepDataChanged.next({
                stepName: this.contractControl.stepNameGenerator(this.contractControl.selectedStep).stepName,
                step: this.contractControl.selectedStep
            }) 
        }) */
        let contractData = this.contractDataService.ContractDataCachedByGuid.get(this.contractGuid)
        let contractStep = contractData?.contract?.roadmap_active.steps?.find(el=>el.guid === nodeData.guid)
        
        contractStep? dialogStepRef.componentInstance.contractStep = contractStep : null
        dialogStepRef.componentInstance.hidePointer = true
        if (contractData) {
          dialogStepRef.componentInstance.contractData = contractData
          dialogStepRef.componentInstance.stepDivData = {
              top: 0,
              stepIsCalculated:true,
              height:900
          }
        }
    }
}